(function ($) {

  // Remove Shopify's ?contact_posted=true (and the form anchor) from the URL
  // so a refresh doesn't re-render the success state and re-open the popup.
  function cleanPostedUrl() {
    try {
      var url = new URL(window.location.href);

      if (url.searchParams.has('contact_posted')) {
        url.searchParams.delete('contact_posted');
        url.hash = '';

        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search
        );
      }
    } catch (e) {}
  }
  function initContactDialog($root) {
    if ($root.data('eoContactReady')) return;
    $root.data('eoContactReady', true);

    var $dialog = $root.find('[data-eo-contact-dialog]').first();

    if (!$dialog.length) return;

    // Move the dialog (and its contact form) out of any surrounding form.
    if (!$dialog.parent().is('body')) {
      $dialog.appendTo('body');
    }

    function open() {
      var dialog = $dialog.get(0);

      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        $dialog.attr('open', 'open');
      }
    }

    function close() {
      var dialog = $dialog.get(0);

      if (dialog && typeof dialog.close === 'function') {
        dialog.close();
      } else {
        $dialog.removeAttr('open');
      }
    }

    $root
      .find('[data-eo-contact-open]')
      .off('click.eoContact')
      .on('click.eoContact', function () {
        open();
      });

    $dialog
      .find('[data-eo-contact-close]')
      .off('click.eoContact')
      .on('click.eoContact', function () {
        close();
      });

    // Click on the backdrop (the dialog element itself) closes it.
    $dialog
      .off('click.eoContact')
      .on('click.eoContact', function (e) {
        if (e.target === this) {
          close();
        }
      });

    // After a successful submission Shopify reloads with
    // ?contact_posted=true. Show confirmation once, then clean the URL.
    if ($dialog.find('[data-eo-contact-success]').length) {
      open();
      cleanPostedUrl();
    }
  }

  function initContainer($root) {
    if ($root.data('eoReady')) return;
    $root.data('eoReady', true);

    // Contact dialog
    initContactDialog($root);

    // Dynamic selected value for selects
    $root.find('[data-extra-option="select"]').each(function () {
      var $wrap = $(this);
      var $select = $wrap.find('[data-extra-select]');
      var $out = $wrap.find('[data-selected-value]');

      if (!$select.length || !$out.length) return;

      function sync() {
        var text = $select.find('option:selected').text();
        $out.text(text);
      }

      $select.on('change', sync);
      sync();
    });

    // Engraving widgets
    $root.find('[data-engraving]').each(function () {
      var $block = $(this);
      var $toggle = $block.find('[data-engraving-toggle]');
      var $panel = $block.find('[data-engraving-panel]');
      var $fontBtns = $block.find('[data-engraving-font]');
      var $fontInput = $block.find('[data-engraving-font-input]');
      var $textInput = $block.find('[data-engraving-text]');
      var $output = $block.find('[data-engraving-output]');
      var $placeholder = $block.find('[data-engraving-placeholder]');
      var $count = $block.find('[data-engraving-count]');

      function applyPreviewFont(handle) {
        if (!$output.length) return;

        var classes = ($output.attr('class') || '')
          .replace(/\beo-font--\S+/g, '')
          .replace(/\s+/g, ' ')
          .trim();

        $output.attr('class', classes);

        if (handle) {
          $output.addClass('eo-font--' + handle);
        }
      }

      function selectFont($btn) {
        $fontBtns
          .removeClass('is-selected')
          .attr('aria-pressed', 'false');

        $btn
          .addClass('is-selected')
          .attr('aria-pressed', 'true');

        if ($fontInput.length) {
          $fontInput.val($btn.attr('data-engraving-font') || '');
        }

        applyPreviewFont($btn.attr('data-font-handle'));
      }

      function updatePreview() {
        var val = $textInput.length ? $textInput.val() : '';
        var has = $.trim(val).length > 0;

        if ($count.length) {
          $count.text(val.length);
        }

        if ($output.length) {
          $output.text(val).prop('hidden', !has);
        }

        if ($placeholder.length) {
          $placeholder.prop('hidden', has);
        }
      }

      function setEnabled(on) {
        if ($panel.length) {
          $panel.prop('hidden', !on);
        }

        $fontInput.add($textInput).prop('disabled', !on);

        if (
          on &&
          $fontBtns.length &&
          !$block.find('[data-engraving-font].is-selected').length
        ) {
          selectFont($fontBtns.eq(0));
        }
      }

      if ($toggle.length) {
        
        $toggle.on('change', function () {
          setEnabled($(this).prop('checked'));
        });
      }

      $fontBtns.on('click', function () {
        selectFont($(this));
      });

      if ($textInput.length) {
        $textInput.on('input', updatePreview);
      }

      setEnabled($toggle.length ? $toggle.prop('checked') : false);
      updatePreview();
    });
  }

  function run() {
    $('[data-extra-options]').each(function () {
      initContainer($(this));
    });
  }

  window.__extraOptionsInit = run;
  $(document).ready(run);

  $('[data-aside-nav-link]').on('click', function (e) {
    e.preventDefault();

    var target = $(this).attr('href');
    var $target = $(target);
    var headerHeight = $('header').outerHeight() || 0;

    if ($target.length) {
        $('html, body').animate({
            scrollTop: $target.offset().top - headerHeight
        }, 500);
    }
  });

  // ── Keep the fixed aside nav within bounds: never above the section's
  //    placement, never overlapping the footer. ──
  function initAsideNav() {
    var $nav = $('.cb-aside-nav').first();
    if (!$nav.length || $nav.data('cbAsideBound')) return;
    $nav.data('cbAsideBound', true);

    var $section = $nav.closest('.cb-aside-nav-section');
    if (!$section.length) $section = $nav.parent();

    var $footer = $('[data-section-type="footer"]').first();
    if (!$footer.length) $footer = $('footer').first();

    // Intended pinned offset = the inline top Liquid set (read once, before we override it).
    var minTop = parseInt($nav.css('top'), 10);
    if (isNaN(minTop)) minTop = 0;

    var GAP = 24;

    function update() {
      // Skip when hidden (e.g. below the mobile breakpoint).
      if (!$nav.is(':visible') || $section.css('display') === 'none') return;

      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      var placedTop = $section.offset().top;      // document Y where the section is placed
      var navH = $nav.outerHeight();

      // Follow the page down from the placement, then pin at minTop.
      var top = placedTop - scrollY;
      if (top < minTop) top = minTop;

      // Never let the nav's bottom cross the footer's top.
      if ($footer.length) {
        var maxTop = $footer.offset().top - GAP - scrollY - navH;
        if (top > maxTop) top = maxTop;
      }

      $nav.css('top', top + 'px');
    }

    var ticking = false;
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    $(window).on('scroll resize load', onScrollOrResize);
    update();
  }

  initAsideNav();

  // ═══════════════════════════════════════════════════════════════════
  // CB APPOINTMENT START
  // ═══════════════════════════════════════════════════════════════════

  function initAppointmentSection($root) {
    if ($root.data('cbApptReady')) return;
    $root.data('cbApptReady', true);

    var $dataEl = $root.find('[data-cb-appt-data]');
    var data = [];
    if ($dataEl.length) {
      try {
        data = JSON.parse($dataEl.text());
      } catch (e) {}
    }

    var byKey = {};
    $.each(data, function (i, s) {
      byKey[s.key] = s;
    });

    var $select = $root.find('[data-cb-appt-select]');
    var $cards = $root.find('[data-cb-appt-shop]');
    var $map = $root.find('[data-cb-appt-map]');
    var $hoursList = $root.find('[data-cb-appt-hours]');
    var $hoursCity = $root.find('[data-cb-appt-hours-city]');

    function apply(key) {
      var s = byKey[key];
      if (!s) return;

      // Update location cards
      $cards.each(function () {
        var $card = $(this);
        $card.toggleClass('is-active', $card.attr('data-cb-appt-shop') === key);
      });

      // Update dropdown
      if ($select.length) {
        $select.find('option').each(function () {
          if ($(this).attr('data-key') === key) {
            $select.prop('selectedIndex', $(this).prop('index'));
          }
        });
      }

      // Update map
      if ($map.length && s.mapSrc) {
        $map.attr('src', s.mapSrc);
      }

      // Update hours
      if ($hoursList.length) {
        $hoursList.html(s.hours || '');
      }

      // Update city label
      if ($hoursCity.length) {
        $hoursCity.text(s.city ? '· ' + s.city : '');
      }
    }

    // Card clicks
    $cards.on('click', function () {
      apply($(this).attr('data-cb-appt-shop'));
    });

    // Dropdown change
    if ($select.length) {
      $select.on('change', function () {
        var $opt = $(this).find('option').eq(this.selectedIndex);
        apply($opt.attr('data-key'));
      });
    }

    // Date inputs: set min to today
    $root.find('[data-cb-appt-date]').each(function () {
      var today = new Date().toISOString().split('T')[0];
      $(this).attr('min', today);
    });

    // Initial selection
    var initKey = null;
    if ($select.length && $select.find('option').length) {
      var $firstOpt = $select.find('option').eq(this.selectedIndex || 0);
      initKey = $firstOpt.attr('data-key');
    }
    if (!initKey && data.length) initKey = data[0].key;
    if (initKey) apply(initKey);

    // Focus success message after form submission
    var $success = $root.find('[data-cb-appt-success]');
    if ($success.length && $success.hasClass('show')) {
      $success.focus();
      $('html, body').animate({
        scrollTop: $success.offset().top - (($('header').outerHeight() || 0) + 20)
      }, 500);
    }
  }

  function runAppointment() {
    $('[data-cb-appointment]').each(function () {
      initAppointmentSection($(this));
    });
  }

  window.cbAppointmentInit = runAppointment;
  runAppointment();

  // ═══════════════════════════════════════════════════════════════════
  // CB APPOINTMENT END
  // ═══════════════════════════════════════════════════════════════════

   // ═══════════════════════════════════════════════════════════════════
  // SIZE GUIDE MODAL (Guide des tailles)
  // ═══════════════════════════════════════════════════════════════════

  function initSizeGuideModals() {
    // Handle size guide open button (data-size-guide-open)
    $('[data-size-guide-open]').off('click').on('click', function (e) {
      e.preventDefault();
      var $btn = $(this);
      // Find the modal - it should be in the same product__extra-options container
      var $container = $btn.closest('[data-extra-options]');
      var $modal = $container.find('[data-size-guide-modal]').first();

      if ($modal.length && typeof $modal.get(0).showModal === 'function') {
        $modal.get(0).showModal();
      } else if ($modal.length) {
        $modal.attr('open', 'open');
      }
    });

    // Handle size guide close button
    $('[data-size-guide-close]').off('click').on('click', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var $modal = $btn.closest('[data-size-guide-modal]');

      if ($modal.length && typeof $modal.get(0).close === 'function') {
        $modal.get(0).close();
      } else if ($modal.length) {
        $modal.removeAttr('open');
      }
    });

    // Close modal when clicking the backdrop
    $('[data-size-guide-modal]').off('click').on('click', function (e) {
      if (e.target === this) {
        var $modal = $(this);
        if (typeof $modal.get(0).close === 'function') {
          $modal.get(0).close();
        } else {
          $modal.removeAttr('open');
        }
      }
    });
  }
  initSizeGuideModals();
  // ═══════════════════════════════════════════════════════════════════
  // SIZE GUIDE MODAL (Guide des tailles) END
  // ═══════════════════════════════════════════════════════════════════

  $(document).on('product:variant-change', function(e){
    var $modalInner = $(e.originalEvent.srcElement.activeElement).closest('.quick-product--modal__inner');
    var variant = e.detail.variant;
    var prodId = variant.featured_image.product_id;
    if (!$modalInner.length) return;
    var $detailsLink = $modalInner.find('.quick-view-view-product-details-link');
    if (variant && variant.id) {
      var href = $detailsLink.attr('href') || '';
      var baseUrl = href.split('?')[0];
      $detailsLink.attr('href', baseUrl + '?variant=' + variant.id);
      $(`[data-prod-id="${prodId}"] a`).attr('href', baseUrl + '?variant=' + variant.id);
    }
  });
})(jQuery);